import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, inject, input, Input, Output } from '@angular/core';
import { BaseControlValueAccessor } from '../../../../util/form/BaseControlValueAccessor';
import { getNgValueAccessorProvider } from "../../../../util/form/value-accessor-export-functions";
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-switcher',
  templateUrl: './switcher.component.html',
  styleUrls: ['./switcher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    ...getNgValueAccessorProvider(SwitcherComponent),
  ],
  imports: [NgClass],
})
export class SwitcherComponent extends BaseControlValueAccessor<boolean> {
  private cdr = inject(ChangeDetectorRef);

  // TODO investigate how to work with input values witch is changed inside component. Also for  BaseControlValueAccessor
  @Input('checked') value: boolean = false;
  @Input() disabled = false;
  @Output() checkedChanged = new EventEmitter<boolean>();

  leftText$$ = input<string>(undefined, { alias: 'leftText' });
  rightText$$ = input<string>(undefined, { alias: 'rightText' });
  noPropagation$$ = input<boolean>(false, { alias: 'noPropagation' });
  id$$ = input<string>(undefined, { alias: 'id' });

  // Keep only the methods where additional logic is needed (e.g., change detection)
  writeValue(value: boolean): void {
    super.writeValue(value);
    this.cdr.markForCheck(); // Additional logic to trigger change detection
  }

  setDisabledState(isDisabled: boolean): void {
    super.setDisabledState(isDisabled);
    this.disabled = isDisabled;
    this.cdr.markForCheck(); // Additional logic to trigger change detection
  }

  onCheckedChange(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.value = checked;

    this.onModelChange(checked); // Call the base class method to handle change
    this.checkedChanged.emit(checked);

    this.cdr.markForCheck();
  }
}
